/* * Filters * */

// Matches the backend's filterType for maxes and goals
const USER_FILTER_TYPE = {
  Athletes: 1,
  Groups: 2,
  Calendars: 3,
  AllAthletes: 4,
};

/* * Exercises * */

// Lift, Circuit, Cardio and Health are the only exercise types with maxes
export const MAX_TRACKABLE_EXERCISE_TYPES = ['L', 'C', 'R', 'H'];

export const EXERCISE_TYPE_ICON = {
  L: 'lift', C: 'circuit', R: 'cardio', H: 'heart',
};

// What a lift's max is measured in
export const LIFT_TRACK = {
  OneRepMax: 1, Reps: 2, ThreeRepMax: 3, Weight: 4,
};

/* * Max sources * */

export const SOURCE_LABEL = {
  WORKOUT: 'Workout',
  DAY_BASED_WORKOUT: 'Workout',
  EVALUATION: 'Evaluation',
  INTEGRATION: 'Integration',
  MANUAL: 'Manual entry',
};

/* * Max History * */

export const HISTORY_RANGE = { Last10: 'last10', Ytd: 'ytd', All: 'all' };

export default USER_FILTER_TYPE;
